import React, { Component } from "react";
import { Box, Text, Spacer, Grid, GridItem, Image, Badge, HStack, Modal, ModalBody, ModalOverlay, ModalCloseButton, ModalContent } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullseye, faSyncAlt } from "@fortawesome/free-solid-svg-icons";

import { JsonViewer } from '@textea/json-viewer'
import _ from "lodash";

import ConfigService from "../../../services/ConfigService";
import CoreService from "../../../services/CoreService";
import LocalStorageService from "../../../services/LocalStorageService";
import ObsSearchParams from "../../../models/ObsSearchParams";

import GCLogo from "../../../assets/images/logos/glasschain-img-only.png";
import { DateTime } from "luxon";

import ReportDataFactory from "./Managers/ReportDataFactory";

import "../../../assets/css/lotreport.css";

export default class ObservationStandardReport extends Component {
  constructor(props) {
    super(props);
    this.configService = new ConfigService();
    this.state = {
      lotNumber: '111577',
      reportData: null,
      isLoading: false,
      errorMessage: "",
      customerLogoImgSrc: "",
      isOpen: false,
      modalSrc: ''
    };

    this.localStorageService = new LocalStorageService();
    this.coreService = new CoreService();

    this.refreshData = this.refreshData.bind(this);
    this.onLotNumberChange = this.onLotNumberChange.bind(this);
    this.onRefreshLotButtonClick = this.onRefreshLotButtonClick.bind(this);


    this.makeHeader = this.makeHeader.bind(this);
    this.makeGenInfo = this.makeGenInfo.bind(this);
    this.makeLotSummaryGradeChart = this.makeLotSummaryGradeChart.bind(this);
    this.makeQualityTable = this.makeQualityTable.bind(this);
    this.makeReadings = this.makeReadings.bind(this);
    this.makeUserImages = this.makeUserImages.bind(this);
    this.makeDocuments = this.makeDocuments.bind(this);
    this.makeReports = this.makeReports.bind(this);
    this.onClose = this.onClose.bind(this);
    this.setModalSrc = this.setModalSrc.bind(this);
  }

  async componentDidMount() {
    let customerLogoImgSrc = this.configService.getCustomerLogoImagePath(this.props.userSession.gcid);
    this.setState({
      customerLogoImgSrc: customerLogoImgSrc
    });
    if (this.props.observationId) {
      await this.refreshData();
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if ((prevProps.observationId !== this.props.observationId) || (prevProps.reportName !== this.props.reportName)) {
      if (this.props.observationId) {
        await this.refreshData();
      }
    }
  }


  onLotNumberChange(ev) {
    var newLotNumber = ev.target.value;
    this.setState({ lotNumber: newLotNumber });
  }

  async onRefreshLotButtonClick(e) {
    await this.refreshData();
  }

  async refreshData() {
    try {
      this.setState({ isLoading: true, errorMessage: "" });
      var dataResponse = await ReportDataFactory.ReportData(this.props.reportName, this.props.observation, this.props.userSession.uid, this.props.userSession.gcid, this.props.userSession.token, this.props.shared);
      // TBD - error handling
      var reportData = dataResponse.data;
      this.setState({ reportData: reportData })
    }
    finally {
      this.setState({ isLoading: false });
    }
  }

  makeHeader(report) {

    var header =
      <Grid
        templateColumns='repeat(16, 1fr)'
        alignItems={"center"}
      >
        <GridItem rowSpan={1} colSpan={4} maxW={'80%'}><Image src={this.state.customerLogoImgSrc} /></GridItem>
        <GridItem colStart={7} colEnd={14}><Text fontSize={32} fontWeight={"bold"}>QC Inspection Report</Text></GridItem>
        <GridItem colStart={14} colEnd={15}><Text fontWeight={"bold"}>Run</Text></GridItem>
        <GridItem colSpan={2} >{DateTime.now().toLocaleString()}</GridItem>
      </Grid>


    return header;
  }

  makeGenInfo(report) {
    var headerData = this.state.reportData.header
    var currLocation = headerData.location.value; //this.props.userSession.currentLocationId
    var general =
      <Grid
        templateColumns='repeat(16, 1fr)'

      >

        <GridItem colSpan={16} h={2} bg="white" />
        <GridItem colSpan={16}><Text fontSize={20} fontWeight={"bold"} bg={"lightblue"}>General Information</Text></GridItem>
        <GridItem colSpan={16} h={2} bg="white" />

        <GridItem colSpan={2}><Text fontWeight={"bold"}>Supplier</Text></GridItem>
        <GridItem colSpan={2}>{headerData.supplier.value}</GridItem>
        <GridItem colStart={8} colEnd={10}><Text fontWeight={"bold"}>Lot</Text></GridItem>
        <GridItem colStart={10} colEnd={12} >{this.state.reportData.header.lot.value}</GridItem>
        <GridItem colStart={12} colEnd={14}><Text fontWeight={"bold"}>Reference</Text></GridItem>
        <GridItem colStart={14} colEnd={16}>{headerData.containerFacturaTransferNo.value}</GridItem>

        <GridItem colSpan={2}><Text fontWeight={"bold"}>Origin Country</Text></GridItem>
        <GridItem colSpan={2}>{headerData.coo.value}</GridItem>
        <GridItem colStart={8} colEnd={10}><Text fontWeight={"bold"}>Location</Text></GridItem>
        <GridItem colStart={10} colEnd={12}>{currLocation}</GridItem>
        <GridItem colStart={12} colEnd={14}><Text fontWeight={"bold"}>Total Cartons</Text></GridItem>
        <GridItem colStart={14} colEnd={16}>{report.totalCartons.value}</GridItem>


        <GridItem colSpan={2}><Text fontWeight={"bold"}>Commodity</Text></GridItem>
        <GridItem colSpan={2} >{report.commodity}</GridItem>
        <GridItem colStart={8} colEnd={10}><Text fontWeight={"bold"}>Date Received</Text></GridItem>
        <GridItem colStart={10} colEnd={12}>{DateTime.fromISO(headerData.arrivalDate.value).toLocaleString()}</GridItem>

      </Grid>


    return general;
  }


  makeGradePctDisplay(defectGroupsDetails)
  {
    var rawPctRaw = defectGroupsDetails?.rawPct ?? 0;
    var result = ((rawPctRaw === 0) && (defectGroupsDetails.rawCount > 0)) ? "<1" : rawPctRaw.toFixed(0);
    return result;
  }


  makeLotSummaryGradeChart(report) {

    var gradeChartData = report.gradeSummary;

    var gradeChartRows = [];
    gradeChartData.map((val) => {
      gradeChartRows.push(
        <Grid templateColumns='repeat(16, 1fr)' textAlign={"center"} >
          <GridItem border={"1px solid #dfdfdf"} textAlign={"left"} colSpan={2}>{val.label}</GridItem>
          <GridItem border={"1px solid #dfdfdf"} colSpan={1} backgroundColor={val.color}>{val.rangeDescription}</GridItem>
          <GridItem border={"1px solid #dfdfdf"} colSpan={2} color={(val.cartons.value > 0) ? "black" : "white"}>{val.cartons?.value ?? 0}</GridItem>
          <GridItem border={"1px solid #dfdfdf"} colSpan={2} color={(val.pallets.value > 0) ? "black" : "white"}>{val.pallets?.value ?? 0}</GridItem>
          <GridItem border={"1px solid #dfdfdf"} colSpan={3} color={(val.defectGroups[0].details.rawCount !== 0) ? "black" : "white"}>{this.makeGradePctDisplay(val.defectGroups[0].details)}%</GridItem>
          <GridItem border={"1px solid #dfdfdf"} colSpan={3} color={(val.defectGroups[1].details.rawCount !== 0) ? "black" : "white"}>{this.makeGradePctDisplay(val.defectGroups[1].details)}%</GridItem>
          <GridItem border={"1px solid #dfdfdf"} colSpan={3} color={(val.defectGroups[2].details.rawCount !== 0) ? "black" : "white"}>{this.makeGradePctDisplay(val.defectGroups[2].details)}%</GridItem>

        </Grid>
      )
    })
    var gradeChartHeader =
      <Grid
        templateColumns='repeat(16, 1fr)'
        textAlign={"center"}
      >
        <GridItem colSpan={16} h={8} bg="white" />
        <GridItem textAlign={"left"} colSpan={16}><Text fontSize={20} fontWeight={"bold"} bg={"lightblue"} marginBottom={1} >Lot Summary</Text></GridItem>

        <GridItem border={"1px solid #dfdfdf"} colSpan={3} rowSpan={2} backgroundColor={"#add8e6"} fontWeight={"bold"}>Total Score</GridItem>
        <GridItem border={"1px solid #dfdfdf"} colSpan={2} rowSpan={2} backgroundColor={"#add8e6"} fontWeight={"bold"}>Total Cartons</GridItem>
        <GridItem border={"1px solid #dfdfdf"} colSpan={2} rowSpan={2} backgroundColor={"#add8e6"} fontWeight={"bold"}>Total Pallets</GridItem>

        <GridItem colSpan={9} rowSpan={2}>
          <Grid templateColumns='repeat(9, 1fr)' fontWeight={"bold"}>
            <GridItem border={"1px solid #dfdfdf"} backgroundColor={"#add8e6"} colSpan={9}>Defect Percentages</GridItem>
            <GridItem border={"1px solid #dfdfdf"} backgroundColor={"#add8e6"} colSpan={3}>Major/Serious Condition</GridItem>
            <GridItem border={"1px solid #dfdfdf"} backgroundColor={"#add8e6"} colSpan={3}>Minor Condition</GridItem>
            <GridItem border={"1px solid #dfdfdf"} backgroundColor={"#add8e6"} colSpan={3}>Minor Appearance</GridItem>
          </Grid>
        </GridItem>

        {/* individual grade rows structure */}

        <GridItem colSpan={16}>
          {gradeChartRows}
        </GridItem>

        {/* totals row */}

        <GridItem backgroundColor={"#add8e6"} border={"1px solid #dfdfdf"} colSpan={3}>{"Total"}</GridItem>
        <GridItem backgroundColor={"#add8e6"} colSpan={2} border={"1px solid #dfdfdf"} >{report.totalCartons.value}</GridItem>
        <GridItem backgroundColor={"#add8e6"} colSpan={2} border={"1px solid #dfdfdf"} >{report.totalPallets.value}</GridItem>

      </Grid>


    return gradeChartHeader;
  }

  makeQualityTable(report) {

    var qualData = report.detailLines.rows

    var headerLabelRow = qualData[0].header.map(val => {
      return <GridItem backgroundColor={"#add8e6"} paddingTop={2} fontWeight={"bold"} border={"1px solid white"}><Text style={{ writingMode: "vertical-lr" }}>{val.label}</Text></GridItem>
    })

    var defectLabelRow = qualData[0].defects.map(val => {
      return <GridItem backgroundColor={"#add8e6"} paddingTop={2} fontWeight={"bold"} border={"1px solid white"}><Text style={{ writingMode: "vertical-lr" }}>{val.label}</Text></GridItem>
    })

    var countRow = [];
    var colorOne = "#deebf7"
    var colorTwo = "#bdd7ee"
    var colorFlip = 1

    qualData.map(data => {
      var currentColor = (colorFlip % 2 == 0) ? colorOne : colorTwo;
      data.header.map(val => {
        countRow.push(<GridItem paddingLeft={3} paddingRight={3} backgroundColor={currentColor} border={"1px solid #dfdfdf"} minWidth={"-webkit-max-content"} ><Text >{val.value}</Text></GridItem>)
      })

      data.defects.map(val => {
        countRow.push(<GridItem backgroundColor={currentColor} border={"1px solid #dfdfdf"} color={(val.value > 0) ? "black" : currentColor}><Text>{val.value.toFixed(1)}</Text></GridItem>)
      })
      colorFlip++
    })

    var colCount = headerLabelRow.length + defectLabelRow.length
    var headerColCount = (colCount / 3).toFixed(0);
    var finalHeaderColCount;
    if ((headerColCount * 3) !== colCount) {
      var newVal = (colCount - (headerColCount * 3))
      finalHeaderColCount = newVal + Number(headerColCount)
    } else {
      finalHeaderColCount = headerColCount
    }

    var conditionCount = 0;

    qualData[0].defects.map(val => {
      if (val.groupLabel.includes("Condition")) {
        conditionCount += 1
      }
    })

    var appearanceCount = qualData[0].defects.length - conditionCount;

    var genQualTable =
      <Grid
        templateColumns={"repeat(" + colCount + ", 1fr)"}
      >
        <GridItem colSpan={colCount} h={4} bg="white" />
        <GridItem colSpan={colCount}><Text fontSize={20} fontWeight={"bold"} bg={"lightblue"}>Quality Assessment</Text></GridItem>
        <GridItem colSpan={colCount} h={2} bg="white" />

        <GridItem backgroundColor={"#add8e6"} fontWeight={"bold"} border={"1px solid white"} colSpan={qualData[0].header.length}>Header Information</GridItem>
        <GridItem backgroundColor={"#add8e6"} fontWeight={"bold"} border={"1px solid white"} colSpan={conditionCount}>Condition</GridItem>
        <GridItem backgroundColor={"#add8e6"} fontWeight={"bold"} border={"1px solid white"} colSpan={appearanceCount}>General Appearance</GridItem>
        {headerLabelRow}
        {defectLabelRow}
        {countRow}
      </Grid>

    return genQualTable;
  }

  makeReadings(report) {

    var readingData = report.readings

    var readingRows = readingData.map(data => {
      return <GridItem colSpan={1} display={"flex"} justifyContent={"space-evenly"} ><Text w="50%" fontWeight={"bold"}>{data.label}</Text><Text w="50%">{data.value}</Text></GridItem>
    })

    var readings =
      <Grid
        templateColumns='repeat(3, 1fr)'
      >
        <GridItem colSpan={3} h={4} bg="white" />
        <GridItem colSpan={3}><Text fontSize={20} fontWeight={"bold"} bg={"lightblue"}>Readings</Text></GridItem>
        <GridItem colSpan={3} h={2} bg="white" />

        {readingRows}

        <GridItem colSpan={3} h={2} bg="white" />
        <GridItem colSpan={3} fontSize={16} fontWeight={"bold"}>Comments</GridItem>
        {/* <GridItem><Badge variant={"outline"}>{report.comments[0]?.pallets ?? ""}</Badge></GridItem> */}
        <GridItem colSpan={3}><Text> {report.comments[0]?.comments ?? ""} </Text></GridItem>
      </Grid>


    return readings;
  }

  makeUserImages(report) {
    var imageData = report.images

    var imageGridItems = imageData.map(data => {
      var fullSrc = this.configService.getGcidUserImageBasePath(this.props.userSession.gcid) + data.imageFile;
      var thumbSrc = this.configService.getGcidUserImageBasePath(this.props.userSession.gcid) + data.thumbnailFile;
      //var imgFull = (data.thumbnailFile !== '') ? data.thumbnailFile : data.imageFile;
      var tags = data.tags.map((tag) => {
        return <Badge>{tag.label}</Badge>
      })

      return <GridItem>
        {/* <Badge variant={"outline"}>{data.pallets}</Badge> */}

        <img src={thumbSrc} onClick={() => this.setModalSrc(fullSrc)} />

        {(data.description) &&
          <Text>{data.description}</Text>
        }
        {tags}

      </GridItem>
    })

    var imageGrid =
      <Grid
        templateColumns="repeat(6, 1fr)"
      >
        <GridItem colSpan={6} h={4} bg="white" />
        <GridItem colSpan={6}><Text fontSize={20} fontWeight={"bold"} bg={"lightblue"}>Inspection Images</Text></GridItem>
        <GridItem colSpan={6} h={2} bg="white" />
        {imageGridItems}
      </Grid>
    return imageGrid
  }


  makeDocuments(report) {
    var docData = report.documents
    var path = this.configService.getGcidUserDocBasePath(this.props.userSession.gcid)
    var docItems = docData.map(data => {
      return <GridItem>
        <Badge variant={"outline"}>{data.pallets}</Badge>
        {/* <Text>{data.description}</Text> */}
        <Text><a href={path + data.docFile} target="_blank">{data.description}</a></Text>
      </GridItem>
    })

    var docGrid =
      <Grid
        templateColumns="repeat(4, 1fr)"
      >
        <GridItem colSpan={4} h={4} bg="white" />
        <GridItem colSpan={4}><Text fontSize={20} fontWeight={"bold"} bg={"lightblue"}>Inspection Documents</Text></GridItem>
        <GridItem colSpan={4} h={2} bg="white" />
        {docItems}
      </Grid>
    return docGrid
  }

  makeReports() {
    var pageNumber = 1;

    var fullReport = [];

    this.state.reportData.commodities.map(report => {

      var footer = < HStack h="15px" marginTop={"2vh"} marginBottom={"2vh"}>
        <Image src={GCLogo} h="35px" />
        <Spacer />
        <Text>Powered By Glasschain</Text>
        <Spacer />
        <Text>Page {pageNumber} of {this.state.reportData.commodities.length}</Text>
      </HStack >

      fullReport.push(this.makeHeader(report))
      fullReport.push(this.makeGenInfo(report))
      fullReport.push(this.makeLotSummaryGradeChart(report))
      fullReport.push(this.makeQualityTable(report))
      fullReport.push(this.makeReadings(report))
      fullReport.push(this.makeUserImages(report))
      fullReport.push(this.makeDocuments(report))
      fullReport.push(footer)
      pageNumber++
    });

    return fullReport;
  }

  onClose() {
    this.setState({
      isOpen: false
    })
  }

  setModalSrc(thisModalSrc) {
    this.setState({
      modalSrc: thisModalSrc,
      isOpen: true
    })
  }

  render() {
    const loadingIcon = this.state.isLoading ? (
      <FontAwesomeIcon style={{ marginTop: "50vh", marginLeft: "50vw" }} icon={faSyncAlt} size="xl" color="green" spin />
    ) : (
      ""
    );



    return (

      <div className='main'>

        <Modal isOpen={this.state.isOpen} onClose={this.onClose} size={'full'}>
          <ModalOverlay />
          <ModalContent>
            <ModalCloseButton />
            <ModalBody style={{margin: "auto"}}>
              <img src={this.state.modalSrc} />
            </ModalBody>
          </ModalContent>
        </Modal>

        {/*
        <InputGroup size='sm'>
          <InputLeftAddon children='Lot Number' />
          <Input
            placeholder='Lot'
            value={this.state.lotNumber}
            onChange={(ev) => this.onLotNumberChange(ev)}
          />
          <Button id="refreshLotButton" onClick={(e) => this.onRefreshLotButtonClick(e)}>Update Report</Button><Spacer />
          <Spacer />
          {loadingIcon}
        </InputGroup>
        <Text id="errormessage" color={"red"}>{this.state.errorMessage}</Text>
    */}
        {loadingIcon}
        {(this.state.reportData) ?
          <Box fontSize={14}>
            {this.makeReports()}
          </Box>
          : ""
        }

        {/*
        {(this.state.reportData) ?
          <Stack spacing={4}>
            <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='20px'>
              <Text fontSize={{ base: '30px', md: '36px', lg: '40px' }} color='white'>Lot {this.state.lotNumber} Report Mockup and Data</Text>
              <Box p='4'>
                <Card>
                  <CardHeader align="center">Report Data Object</CardHeader>
                  <CardBody>
                    <div style={{ width: "100%", height: "100%" }}>
                      <Stack direction={['column', 'row']}>
                        <Box>
                          <JsonViewer
                            value={this.state.reportData}
                          />
                        </Box>
                      </Stack>
                    </div>
                  </CardBody>
                </Card>
              </Box>
            </Box>
          </Stack>
          : <span />
        }
      */}
      </div>
    );
  }
}
